import { Pipe, PipeTransform } from '@angular/core';
import { LookupService } from '../services';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Pipe({
  name: 'userName',
})
export class UserNamePipe implements PipeTransform {
  constructor(private lookupSvc: LookupService) {}

  transform(userId?: number, mode: string = 'full'): Observable<string> {
    if (userId === 0) return of('System');
    if (!userId) return of('');
    return this.lookupSvc.userName$(userId).pipe(
      filter((u) => !!u),
      map((u) => {
        switch (mode) {
          case 'chat':
            return `${u.first} ${u.last.slice(0, 1)}`;
            break;
          case 'name':
            return `${u.first} ${u.last}`;
            break;
          default:
            return `${u.userId} - ${u.first} ${u.last}`;
            break;
        }
      })
    );
  }
}
